"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrokerAnswerFeedbackTextRequired = exports.BrokerAnswerGrade = exports.BrokerAnswerHelpfulness = exports.InquiryAssistantQuestion = void 0;
var InquiryAssistantQuestion;
(function (InquiryAssistantQuestion) {
    InquiryAssistantQuestion["EXPLAIN_DENIAL_REASONS"] = "explain_denial_reasons";
    InquiryAssistantQuestion["NEXT_STEP_ON_APPLICATION"] = "next_step_on_application";
    InquiryAssistantQuestion["CURRENT_STAGE_MEANING"] = "current_stage_meaning";
})(InquiryAssistantQuestion || (exports.InquiryAssistantQuestion = InquiryAssistantQuestion = {}));
/** @TranslateToPython */
var BrokerAnswerHelpfulness;
(function (BrokerAnswerHelpfulness) {
    BrokerAnswerHelpfulness["HELPFUL"] = "helpful";
    BrokerAnswerHelpfulness["NOT_HELPFUL"] = "not_helpful";
})(BrokerAnswerHelpfulness || (exports.BrokerAnswerHelpfulness = BrokerAnswerHelpfulness = {}));
/** An Aven employee's grade on an AI-generated answer to a broker support question. */
/** @TranslateToPython */
var BrokerAnswerGrade;
(function (BrokerAnswerGrade) {
    BrokerAnswerGrade["CORRECT"] = "correct";
    BrokerAnswerGrade["INCORRECT"] = "incorrect";
    // The answer does not apply to the call, e.g. a loan officer picked an unrelated ticket just to join the support room.
    BrokerAnswerGrade["NOT_APPLICABLE"] = "not_applicable";
})(BrokerAnswerGrade || (exports.BrokerAnswerGrade = BrokerAnswerGrade = {}));
// A not-applicable grade carries no signal about answer quality without the grader's reason.
const isBrokerAnswerFeedbackTextRequired = (grade) => {
    return grade === BrokerAnswerGrade.NOT_APPLICABLE;
};
exports.isBrokerAnswerFeedbackTextRequired = isBrokerAnswerFeedbackTextRequired;
